// 其他資訊面板 - 繁體中文
export default {
  tabs: {
    imtoken: "imtoken操作資訊",
    tokenPocket: "TokenPocket登入資訊",
    bitpie: "Bitpie自定義標籤",
  },
  loading: { text: "拼命加載中" },
  total: {
    prefix: "共計",
    suffix: "條數據",
  },
  actions: {
    download: "下載",
  },
  table1: {
    operationType: "操作類型",
    operationTypeExplain: "操作類型說明",
    ip: "IP地址",
    ipGeo: "IP地理位置",
    operateTime: "操作時間",
  },
  table2: {
    loginDevice: "登入設備",
    ipAddress: "IP地址",
    port: "端口",
    ipGeo: "IP地理位置",
    operateTime: "操作時間",
  },
  dialog: {
    titleImTokenExplain: "imToken錢包的操作類型說明",
  },
  empty: "暫無數據",
  downloadFileName: "TokenPocket登入資訊",
};
